import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Legend, Tooltip } from 'chart.js';

Chart.register(ArcElement, Legend, Tooltip);

interface ImpressoesPorDispositivoChartProps {
    series: any;
    activeDeviceIndex?: number | null;
    onHover?: (index: number | null) => void;
}

const ImpressionsByDeviceChart = ({ series, activeDeviceIndex, onHover }: ImpressoesPorDispositivoChartProps) => {
    // Device color mapping for consistency
    const getDeviceColor = (device: string) => {
        const deviceLower = device.toLowerCase();
        if (deviceLower.includes('desktop') || deviceLower.includes('pc')) return '#0d6efd'; // primary
        if (deviceLower.includes('mobile') || deviceLower.includes('phone')) return '#198754'; // success
        if (deviceLower.includes('tablet') || deviceLower.includes('ipad')) return '#ffc107'; // warning
        if (deviceLower.includes('tv') || deviceLower.includes('smart')) return '#0dcaf0'; // info
        if (deviceLower.includes('watch')) return '#6c757d'; // secondary
        return '#6c757d'; // muted
    };

    const data: any = {
        labels: series.map((row: any) => row.device.charAt(0).toUpperCase() + row.device.slice(1)),
        datasets: [
            {
                label: 'Impressões',
                backgroundColor: series.map((row: any, index: number) => {
                    if (activeDeviceIndex === index) {
                        return getDeviceColor(row.device);
                    }
                    return getDeviceColor(row.device) + '80'; // Add transparency for inactive segments
                }),
                borderColor: series.map((row: any, index: number) => {
                    if (activeDeviceIndex === index) {
                        return getDeviceColor(row.device);
                    }
                    return getDeviceColor(row.device);
                }),
                borderWidth: series.map((row: any, index: number) => {
                    return activeDeviceIndex === index ? 3 : 1;
                }),
                data: series.map((row: any) => row.impression),
            },
        ],
    };
    const option: any = {
        responsive: false,
        layout: {
            padding: 20,
        },
        plugins: {
            legend: {
                display: false,
            },
        },
        onHover: (event: any, elements: any) => {
            if (onHover) {
                if (elements.length > 0) {
                    onHover(elements[0].index);
                } else {
                    onHover(null);
                }
            }
        },
        interaction: {
            intersect: false,
        },
    };
    return <Doughnut height={250} data={data} options={option} style={{ margin: '0 auto' }}/>;
};

export default ImpressionsByDeviceChart;